// extracted by mini-css-extract-plugin
export default {"discounts":"wtwWbHntvxUEAa_yNhUB","discountsLabelContainer":"GDxMGtKy38Yf9t52Wu2C","discountsPrice":"Hgn3vOz4BnnkDW758Ng_"};